import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { createRef, Ref, ref } from 'lit/directives/ref.js';
import { CellModel, editors, isFormula } from '@omegagrid/grid';

/**
 * Plain text cell editor for values that may start with '=' without being
 * grid formulas - the report cell references of the plot bands. Unlike the
 * default grid TextEditor it does not switch to the formula editor when the
 * value starts with '=', and it commits such values with a leading space so
 * the grid does not turn them into own formulas. The space is stripped
 * again before the value is stored into the view options.
 */
@customElement('rp-grid-textcelleditor')
export class TextCellEditor extends editors.BaseEditor {

	static styles = [editors.BaseEditor.baseStyles, css`
		input {
			outline: none;
			border: 1px solid var(--og-accent-color);
			background: var(--og-cell-background);
			color: var(--og-text-color);
			width: 100%;
			height: 100%;
			padding: 0;
			font-family: var(--og-font-family);
			font-size: var(--og-font-size);
			box-sizing: border-box;
		}
	`];

	inputRef: Ref<HTMLInputElement> = createRef();
	get input() { return this.inputRef.value }

	render() {
		return html`
			<input ${ref(this.inputRef)}
				type="text"
				@blur="${() => { this.commit(); this.close(); }}"
				@keyup="${() => this.validate()}">
		`;
	}

	activate(cell: CellModel) {
		super.activate(cell);
		// edit a stored reference without its space prefix
		this.input.value = cell.value == null ? '' : cell.value.toString().replace(/^ +(?==)/, '');
		this.input.focus();
	}

	getValue(): string {
		const value = this.input.value;
		return isFormula(value) ? ' ' + value : value;
	}

	setValue(value: unknown) {
		this.input.value = value == null ? '' : value.toString();
	}

}
